









































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {perRoadStore, structureStore} from "@/store/store";
import {UnitSystem} from "@/interfaces/units";
import {createStructureValidations} from "@/modules/structure/lib/validations";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import {
  convertDeterministicLayersImperial,
  convertDeterministicLayersMetric
} from "@/modules/structure/lib/convertLayers";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {combineWesleaConfigSet, setCurrentResponseConfig} from "@/modules/structure/lib/createWesleaConfig";
import LayerResults from "@/modules/structure/views/LayerResults.vue";
import ResultsOverview from "@/modules/structure/views/ResultsOverview.vue";
import {
  IWesleaConfig,
  IWesleaConfigBatch,
  IWesleaResult,
  IWesleaResultBatch
} from "@/modules/perRoad/interfaces/monteCarlo";

// import Module from "../../../lib/weslea-wasm/build/web/weslea.js";
// import {wesleaTestConfig} from "../../../../tests/unit/perRoad/testData";
// //
// Module().then(module => {
//   console.log("Module loaded");
//
//   try {
//     // const result = module.runLea(JSON.stringify(wesleaTestConfig));
//     const configJson = JSON.stringify(wesleaTestConfig);
//     const result = module.runLea(configJson);
//     console.log('leaResult', result);
//   } catch (exception) {
//     console.error(module.getExceptionMessage(exception));
//   }
//
//
//
// })

Component.registerHooks(["validations"]);

@Component({
  components: {
    ResultsOverview,
    LayerResults,
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PavementStructureResults extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;


  plotKey = 0;

  get scenario() {
    return structureStore.currentScenario;
  }

  get scenarioImperial() {
    return structureStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get simulatedLayers() {
    this.plotKey += 1;
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return convertDeterministicLayersImperial(this.scenario.structureLayers);
    } else {
      return convertDeterministicLayersMetric(this.scenario.structureLayers);
    }
  }

  incrementPlotKey() {
    this.plotKey += 1;
  }

  sync() {
    structureStore.setCurrentScenario(this.scenario);
    this.incrementPlotKey();
  }

  save() {
    this.sync();
    structureStore.saveCurrentScenario();
  }

  validations() {
    return createStructureValidations(this.scenarioImperial, this.page);
  }

  get combinedWesleaConfig() {
    if (this.scenario.wesleaConfigs) {
      return combineWesleaConfigSet(this.scenario.wesleaConfigs);
    }
    return [];
  }


  combinedWesleaResults: IWesleaResult[] = [];

  // get combinedWesleaResults() {
  //   console.log("Trigger Weslea Results", this.scenario.wesleaResults);
  //   if (this.scenario.wesleaResults) {
  //     return [...Object.values(this.scenario.wesleaResults)].flat();
  //   }
  //   return [];
  // }
  setCombinedWesleaResults(results: IWesleaResult[]) {
    // this.combinedWesleaResults = results.sort((a, b) => {
    //   return a.normal_strain.x < b.normal_strain.x;
    // });
    this.combinedWesleaResults = results;
  }

  currentlyRunning = false;
  completedDraws = 0;

  runAllConfigs() {
    this.scenario.wesleaResults = [];
    const startTime = performance.now();
    this.currentlyRunning = true;

    const configObj: IWesleaConfigBatch = {};
    this.scenario.wesleaConfigs.forEach(c => {
      configObj[c.drawId] = c;
    });

    this.completedDraws = 0;
    Object.entries(configObj).forEach(kv => {
      const drawId = kv[0];
      const wesConfig = kv[1];

      const packagedConfig: { [index: string]: IWesleaConfig } = {};
      packagedConfig[drawId] = wesConfig;

      perRoadStore.runManySimulations(packagedConfig).then((resultBatch: IWesleaResultBatch) => {
        const id = Object.keys(resultBatch)[0];
        const result = Object.values(resultBatch)[0];
        console.log(id, result);
        this.completedDraws += 1;

        result.forEach(r => {
          // console.log(r.normal_strain)
          if (Math.abs(r.normal_strain.x) < .1){
            this.scenario.wesleaResults.push(r);
            console.log(r.normal_strain)
          }
        })

        // this.scenario.wesleaResults.push(...result);

        this.sync();
        if (this.completedDraws === Object.entries(configObj).length) {
          this.currentlyRunning = false;
          this.setCombinedWesleaResults(this.scenario.wesleaResults);
          this.incrementPlotKey();
        }
      });


    });
    // perRoadStore.runManySimulations(configObj).then((results: IWesleaResultBatch) => {
    //   this.scenario.wesleaResults = [...Object.values(results)].flat();
    //   this.setCombinedWesleaResults(this.scenario.wesleaResults);
    //   this.plotKey += 1;
    //   const endTime = performance.now();
    //   console.log(`Total time: ${(endTime - startTime) / 1000} seconds`);
    // }).then(() => {
    //   this.currentlyRunning = false;
    //   this.incrementPlotKey();
    // });
  }

  mounted() {
    if (this.scenario.wesleaConfigs) {
      this.runAllConfigs();
    } else {
      this.scenario.wesleaConfigs = setCurrentResponseConfig(this.scenario);
      this.runAllConfigs();
    }
  }
}

